import { Routes } from '@angular/router';
import { ComponentsComponent } from './components.component';
import { TypographyComponent } from './typography/typography.component';
import { FaqComponent } from './faq/faq.component';

export const ComponentsRoutes: Routes = [
    {
        path: 'faq',
        component: FaqComponent,
        data: { title: "FAQ's" }
    },
    {
        path: 'faq/:id',
        component: FaqComponent,
        data: { title: "FAQ's" }
    },
    {
        path: 'components',
        component: ComponentsComponent,
        children: [
            {
                path: 'typography',
                component: TypographyComponent,
                data: { title: 'Typography' }
            }
        ]
    }
];

